import * as React from 'react'

import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'

interface IProps {
  title: string
  applyButtonText: string
  cancelButtonText?: string
  children: React.ReactNode
  isShown: boolean
  onHide: () => void
  onApply: () => void
  isApplyDisabled?: boolean
  useRedConfirmationButton?: boolean
}

@observer
export default class DeliveryConfirm extends React.Component<IProps> {
  public render() {
    const {
      title,
      applyButtonText,
      cancelButtonText,
      children,
      isShown,
      onHide,
      onApply,
      isApplyDisabled,
      useRedConfirmationButton,
    } = this.props

    return (
      <ConfirmDialog
        isOpen={isShown}
        title={title}
        onCancelClicked={onHide}
        onDoneClicked={onApply}
        doneTitle={applyButtonText}
        cancelTitle={cancelButtonText}
        doneDisabled={isApplyDisabled}
        useRedConfirmationButton={useRedConfirmationButton}
      >
        <div className="tw:text-body-md tw:text-foreground">{children}</div>
      </ConfirmDialog>
    )
  }
}
